/**
 * P9 – Monitoring léger : enregistrement des événements offline/online et des échecs de requêtes.
 * En dev, les événements sont loggés en console pour mesurer la fréquence des coupures ou timeouts.
 */

export type NetworkMonitorEvent =
  | { type: 'online'; at: number }
  | { type: 'offline'; at: number }
  | { type: 'query_error'; at: number; message?: string };

const MAX_EVENTS = 50;
const events: NetworkMonitorEvent[] = [];

function isDev(): boolean {
  return process.env.NODE_ENV === 'development';
}

export function recordOnline(): void {
  events.push({ type: 'online', at: Date.now() });
  if (events.length > MAX_EVENTS) events.shift();
  if (isDev()) {
    console.log('[NetworkMonitor] En ligne', new Date().toISOString());
  }
}

export function recordOffline(): void {
  events.push({ type: 'offline', at: Date.now() });
  if (events.length > MAX_EVENTS) events.shift();
  if (isDev()) {
    console.warn('[NetworkMonitor] Hors ligne', new Date().toISOString());
  }
}

export function recordQueryError(message?: string): void {
  events.push({ type: 'query_error', at: Date.now(), message });
  if (events.length > MAX_EVENTS) events.shift();
  if (isDev()) {
    console.warn('[NetworkMonitor] Échec requête réseau', message ?? '');
  }
}

export function getRecentEvents(): NetworkMonitorEvent[] {
  return [...events];
}

export function getStats(): { online: number; offline: number; queryErrors: number } {
  const stats = { online: 0, offline: 0, queryErrors: 0 };
  events.forEach((e) => {
    if (e.type === 'online') stats.online++;
    else if (e.type === 'offline') stats.offline++;
    else stats.queryErrors++;
  });
  return stats;
}
